import { axiosBasic } from "../../../api/axios";
import { config } from "../../../api/endPoints";

const { BonusPolicy } = config.REST_API;

const omitEmptyParams = (obj) => {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === undefined || v === null || v === "") continue;
    out[k] = v;
  }
  return out;
};

const fetchBonusExportBlob = async (path, query) => {
  const res = await axiosBasic.get(path, {
    params: omitEmptyParams(query),
    responseType: "blob",
  });
  const blob = res.data;
  if (blob instanceof Blob && blob.type && blob.type.includes("application/json")) {
    const text = await blob.text();
    try {
      const json = JSON.parse(text);
      if (json && json.success === false) {
        throw new Error(json.message || "Export failed");
      }
    } catch (e) {
      if (e instanceof Error && e.message !== "Export failed") throw e;
      throw new Error(text || "Export failed");
    }
  }
  return blob;
};

/**
 * @param {object} filters
 * @param {string} [filters.search]
 * @param {string|number} [filters.amountType]
 * @param {string|number} [filters.departmentId]
 * @param {string|number} [filters.officeId]
 * @param {string} [filters.scope] allEmployees | selected
 * @param {string} [filters.status] active | inactive
 */
export const buildBonusExportQuery = (filters) => {
  const q = {};
  const search = String(filters.search ?? "").trim();
  if (search) q.search = search;
  if (filters.amountType != null && filters.amountType !== "" && filters.amountType !== "all") {
    q.amountType = Number(filters.amountType);
  }
  if (filters.departmentId != null && filters.departmentId !== "" && filters.departmentId !== "all") {
    q.departmentId = Number(filters.departmentId);
  }
  if (filters.officeId != null && filters.officeId !== "" && filters.officeId !== "all") {
    q.officeId = Number(filters.officeId);
  }
  if (filters.scope != null && filters.scope !== "" && filters.scope !== "all") {
    q.scope = String(filters.scope);
  }
  if (filters.status != null && filters.status !== "" && filters.status !== "all") {
    q.status = String(filters.status);
  }
  return q;
};

export const fetchBonusExportExcel = (query) => fetchBonusExportBlob(BonusPolicy.ExportExcel, query);

export const fetchBonusExportCsv = (query) => fetchBonusExportBlob(BonusPolicy.ExportCsv, query);

export const fetchBonusExportPdf = (query) => fetchBonusExportBlob(BonusPolicy.ExportPdf, query);

export const bonusExportBasename = () => {
  const stamp = new Date().toISOString().slice(0, 10).replace(/-/g, "");
  return `Bonuses_${stamp}`;
};
